import { makeStyles } from '@material-ui/core';
import { vh } from 'src/common/helpers/dimension-helper';

export const styles = makeStyles(theme => ({
  addButton: {
    maxWidth: '17.56vw',
    fontSize: vh(2.08),
    lineHeight: 1.1,
  },
  closeButton: {
    width: '11.56vw',
    marginRight: '0.88vw',
  },
  buttonGrid: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  navigationLabel: {
    fontFamily: '"Roboto", Helvetica, Arial, sans-serif',
    fontSize: vh(2.08),
    fontWeight: 500,
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 1,
    letterSpacing: 0.7,
    color: theme.palette.info.dark,
    textAlign: 'center',
  },
  arrowButtons: {
    color: theme.palette.info.main,
  },
}));
